import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { FadeIn } from './FadeIn';
import { trackAddToCart } from '../utils/metaPixel';
export function WhatYouGet() {
  const deliverables = [{
    title: "El Ebook Maestro 'Escudo de Confianza'",
    description: 'Guía paso a paso con la metodología completa.'
  }, {
    title: 'El Método N.E.A.',
    description: 'Guiones exactos de qué decir y cómo decirlo.'
  }, {
    title: 'Entrenamiento de Lenguaje Corporal',
    description: 'La postura que evita que lo elijan como blanco.'
  }, {
    title: 'El Mapa de Seguridad del Colegio',
    description: 'Técnica para identificar zonas rojas y verdes.'
  }, {
    title: 'Bitácora de Incidentes',
    description: 'La plantilla legal para obligar al colegio a actuar.'
  }, {
    title: 'Plan de Reconstrucción de Autoestima',
    description: 'Ejercicios para sanar el autoconcepto.'
  }];
  return <section className="py-24 md:py-32 bg-white" data-id="element-470">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl" data-id="element-471">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-472">
          <div data-id="element-473">
            <FadeIn data-id="element-474">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-navy mb-6" data-id="element-475">
                Lo que obtienes hoy
              </h2>
              <div className="w-24 h-1 bg-amber rounded-full mb-12" data-id="element-476"></div>
            </FadeIn>

            <div className="space-y-6" data-id="element-477">
              {deliverables.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-478">
                  <div className="flex items-start gap-4" data-id="element-479">
                    <div className="flex-shrink-0 mt-1" data-id="element-480">
                      <CheckCircle2 className="text-teal" size={24} data-id="element-481" />
                    </div>
                    <div data-id="element-482">
                      <h3 className="text-xl font-bold text-navy mb-1" data-id="element-483">
                        {item.title}
                      </h3>
                      <p className="text-navy/70" data-id="element-484">{item.description}</p>
                    </div>
                  </div>
                </FadeIn>)}
            </div>
          </div>

          <div className="flex justify-center lg:justify-end" data-id="element-485">
            <FadeIn direction="left" data-id="element-486">
              <div className="relative" data-id="element-487">
                <div className="absolute -inset-4 bg-teal/10 rounded-3xl transform -rotate-3 blur-sm" data-id="element-488"></div>
                <img src="https://cdn.magicpatterns.com/uploads/gbPfC8fCK5mNeKSZVwEg93/ESCUDO_DE_CONFIANZA.png" alt="Ebook Escudo de Confianza" className="relative z-10 w-full max-w-md rounded-2xl shadow-2xl" data-id="element-489" />
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}